import { render } from "./newpichart.vue?vue&type=template&id=7d200e0f&scoped=true"
import script from "./newpichart.vue?vue&type=script&lang=js"
export * from "./newpichart.vue?vue&type=script&lang=js"

import "./newpichart.vue?vue&type=style&index=0&id=7d200e0f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d200e0f"]])

export default __exports__